import { computed, Injectable, Signal } from '@angular/core';
import { Navigation } from 'app/core/navigation/navigation.types';
import { Observable, of } from 'rxjs';
import { SignalStateService } from '../service/signal-state-service';
import { AuthService } from '../auth/auth.service';
import { Role, User } from '../user/user.types';
import { navigationConfig } from './navigation.config';

interface NavigationState {
    navigation: Navigation;
}
@Injectable({ providedIn: 'root' })
export class NavigationService
    extends SignalStateService<NavigationState> {
    user!: Signal<User | null>;
    userRole!: Signal<Role | null>;
    /**
     * Constructor
     */
    constructor(private authService: AuthService) {
        super({
            navigation: {
                compact: [],
                default: [],
                futuristic: [],
                horizontal: [],
            },
        });
        this.user = this.authService.user;
        this.userRole = computed(() => {
            return this.user()?.role || null;
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation(): Signal<Navigation> {
        return this.select('navigation');
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation> {
        const filteredNavigationConfig = computed(() =>
            navigationConfig.filter((item) => {
                if (item.roles) {
                    return item.roles.includes(this.userRole()!);
                }
                return true;
            })
        );
        this.setState({
            navigation: {
                compact: filteredNavigationConfig(),
                default: filteredNavigationConfig(),
                futuristic: filteredNavigationConfig(),
                horizontal: filteredNavigationConfig(),
            } as Navigation
        });
        return of(this.navigation());
    }
}
